// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChartWrapper_wrapper__2NvVp","headerWrapper":"ChartWrapper_headerWrapper__3mD_R","icon":"ChartWrapper_icon__3e8hI","chartWrapper":"ChartWrapper_chartWrapper__3gwM1"};